import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const cMLoaApi = createApi({
  reducerPath: 'cMLoaApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Loa'],
  endpoints: (builder) => ({
   
   
    getLoa: builder.query({
      query: (params) => ({
        url: `/campaigns/campaign-loa/`,
        params,
      }),
      providesTags: ['Campaigns'],
    }),

    createLoa: builder.mutation({
      query: (body) => ({
        url: '/campaigns/campaign-loa/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Campaigns'],
    }),
    
  }),
});

export const {
  useGetLoaQuery,
  useLazyGetLoaQuery,
  useCreateLoaMutation,
} = cMLoaApi;